export enum EditableDataTableState {
  VIEW,
  EDIT,
}
